
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { ReferenceDataType } from "@/store/referenceData/types";
import splitStringOnCapital from "@/plugins/filters/stringFilter";
import api from "@/api/signup/api";
import { format } from "date-fns";
import { getReferenceDataDescription } from "@/helpers/referenceData";
import { InvoiceFrequency } from "@/constants/invoiceFrequency";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  computed: {
    billingPlans: () => {
      const promoCode =
        store.state.promoOffer.promoCode && store.state.promoOffer.promoCode.id;

      const paymentTermCode =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.paymentTerm;

      const paymentMethod =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.paymentMethod;

      if (promoCode) {
        const paymentTerm = getReferenceDataDescription(
          paymentTermCode,
          ReferenceDataType.BillingPlan
        );

        return `${paymentTerm} - ${paymentMethod &&
          splitStringOnCapital(paymentMethod)}`;
      }

      return "DD10 - 10 payment days Direct Debit";
    },
    billingFrequency: () => {
      const invoiceDate =
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.invoiceDate;

      const invoiceFrequency = InvoiceFrequency.find(
        freq => freq.value === invoiceDate
      );

      return invoiceFrequency && invoiceFrequency.secondaryLabel;
    },
    customerType: () => {
      const promoCodeCustomerType =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.customerType;

      const standardOfferCustomerType =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.customerType;

      const customerTypeCode =
        promoCodeCustomerType || standardOfferCustomerType;

      return getReferenceDataDescription(
        customerTypeCode,
        ReferenceDataType.CustomerType
      );
    },
    ...mapState({
      creditLimit: (state: IApplicationState) =>
        state.applicationData && state.applicationData.creditLimit,
      applicationId: (state: IApplicationState) =>
        state.applicationData && state.applicationData.id,
      businessName: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.businessName,
      tradingName: (state: IApplicationState) =>
        (state.applicationData &&
          state.applicationData.businessDetails &&
          state.applicationData.businessDetails.tradingName) ||
        (state.applicationData &&
          state.applicationData.businessDetails &&
          state.applicationData.businessDetails.businessName),
      sourceRegisterUniqueIdentifier: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.business &&
        state.applicationData.businessDetails.business
          .sourceRegisterUniqueIdentifier,
      dateReceived: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.submittedDate &&
        format(state.applicationData.submittedDate, "dd/MM/yy")
    })
  },
  validations: {}
});
